// This file is automatically generated by webgen from the struct descriptions in /generated-json/structs.
// Files in /generated-json are created from the structs configured in the 'main' function of /cmd/struct2json/main.go.
//
// DO NOT EDIT THIS FILE except where designated below.

/* eslint-disable no-relative-import-paths/no-relative-import-paths */

import type { PartialDeep } from 'type-fest';

import type { ExcludeMethodsDeep } from '../../../utils/types';
import { NIL_UUID } from '../../../utils/uuid';
import { Company, type CompanyWireFormat, NewCompany } from '../Company/Company';

export class Contact {
  readonly id: string;
  readonly firstName: string;
  readonly lastName: string;
  readonly emailAddress: string | null;
  readonly phoneNumber: string | null;
  readonly company: Company;
  readonly jobTitle: string | null;
  readonly notes: string | null;
  readonly isArchived: boolean;

  constructor(data: { [key: string]: any } = {}) {
    this.id = data.id === undefined ? NIL_UUID : data.id;
    this.firstName = data.firstName === undefined ? '' : data.firstName;
    this.lastName = data.lastName === undefined ? '' : data.lastName;
    this.emailAddress = data.emailAddress === undefined ? null : data.emailAddress;
    this.phoneNumber = data.phoneNumber === undefined ? null : data.phoneNumber;
    this.company = NewCompany(data.company);
    this.jobTitle = data.jobTitle === undefined ? null : data.jobTitle;
    this.notes = data.notes === undefined ? null : data.notes;
    this.isArchived = data.isArchived === undefined ? false : data.isArchived;
  }

  static zero(): Contact {
    const zeroValues: ExcludeMethodsDeep<Contact> = {
      id: NIL_UUID,
      firstName: '',
      lastName: '',
      emailAddress: null,
      phoneNumber: null,
      company: Company.zero(),
      jobTitle: null,
      notes: null,
      isArchived: false,
    };
    return new Contact(zeroValues);
  }

  // ************* DO NOT EDIT ABOVE THIS LINE *************

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  fullName() {
    return `${this.firstName} ${this.lastName}`;
  }

  // ************* DO NOT EDIT BELOW THIS LINE *************
}

export type ContactWireFormat = {
  id: string;
  firstName: string;
  lastName: string;
  emailAddress: string | null;
  phoneNumber: string | null;
  company: CompanyWireFormat;
  jobTitle: string | null;
  notes: string | null;
  isArchived: boolean;
};

type NewContactProps = PartialDeep<Contact, { recurseIntoArrays: true }>;
export const NewContact: (props: NewContactProps) => Contact = (props) => new Contact(props);

type NewContactFromWireFormatProps = PartialDeep<ContactWireFormat, { recurseIntoArrays: true }>;
export const NewContactFromWireFormat: (props: NewContactFromWireFormatProps) => Contact = (
  props,
) => new Contact(props);
